
<div class="container-fluid">
    <div class="row g-4">
      <div class="col-12">
        <mat-card>
          <mat-card-content>
          
            <div *ngIf="isSemesterList">
            <button mat-flat-button color="primary" (click)="addSemester()">
              Add Semester 
            </button>
            <button mat-flat-button color="primary" (click)="getSemesterList_download()">
              Download Full List
            </button>
          </div>
           
           <div *ngIf="!isSemesterList || isEdit">
            <form [formGroup]="formGroup">
             
              <!-- Contact Information Section -->
              <div lass="row g-4 mt-3">
                <div class="col-12">
                  <h6 class="section-title">Semester</h6>
                </div>

              

                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Semester name :</mat-label>
                    <input matInput formControlName="name" placeholder="Enter Semester name" type="text">
                    <mat-error *ngIf="formGroup.get('name')?.errors?.['required']">
                        Semester name is required
                    </mat-error>
                  </mat-form-field>
                </div>
                
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Sem number :</mat-label>
                    <input matInput formControlName="number" placeholder="Enter sem number " type="number">
                    <mat-error *ngIf="formGroup.get('number')?.errors?.['required']">
                        sem number is required
                    </mat-error>
                  </mat-form-field>
                </div>
                
              </div>
              

              <div class="row mt-4">
                <div class="col-12">
                  <div class="d-flex gap-3">
                    <button mat-flat-button color="primary" [disabled]="isLoading " (click)="saveSemester()" class="px-4 py-2">
                        {{ isEdit ? 'Update' : 'Save' }}
                    </button>
                    <button mat-stroked-button [disabled]="isLoading" (click)="resetForm()" class="px-4 py-2">
                      RESET
                    </button>
  
                    <button *ngIf="isEdit || !isSemesterList" mat-flat-button color="primary"  (click)="back()" class="px-4 py-2">
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </mat-card-content>
      </mat-card>
      </div>
      </div>
      </div>
  
      <div *ngIf="isSemesterList">
        <div class="sorting-table">
          <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        
            <!-- Dynamic Columns -->
            <ng-container *ngFor="let column of displayedColumns.cols; let i = index" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ displayedColumns.label[i] | uppercase }}
              </th>
        
              <td mat-cell *matCellDef="let row; let rowIndex = index">
                <ng-container *ngIf="column === 'sno'; else otherCols">
                  {{ currentPage + (rowIndex +1)}}
                </ng-container>
                <ng-container *ngIf="column === 'createdAt'">
                    {{ row.createdAt | date:'dd/MM/yyyy'}}
                  </ng-container>
  


                <ng-template #otherCols>
                  <ng-container *ngIf="!['createdAt'].includes(column)">{{ row[column] }}</ng-container>
                  <!-- {{ row[column] }} -->
                </ng-template>
              </td>
            </ng-container>
        
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef> Actions </th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="edit(row)">
                    <mat-icon>edit</mat-icon> Edit
                  </button>
                  <button mat-menu-item (click)="delete(row)">
                    <mat-icon>delete</mat-icon> Delete
                  </button>
                </mat-menu>
              </td>
            </ng-container>
        
            <!-- Table Headers and Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns.cols.concat(['actions'])"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns.cols.concat(['actions'])"></tr>
        
          </table>
        </div>
        <mat-paginator
            [pageSizeOptions]="[5, 10, 15, 20]"
            [length]="pagination.length"
            [pageIndex]="pagination.page - 1"
            [pageSize]="pagination.limit"
            (page)="pageEvent($event)"
            *ngIf="pagination.length">
        </mat-paginator>
      </div>
      
  